export default {
    STATUS_REQUEST: 'request',
    STATUS_APPLY: 'apply'
}